import emailField from './emailField';
export {
  emailField,
};



/** WEBPACK FOOTER **
 ** ./src/helpers/form/filters/validations/index.js
 **/